module.exports = __webpack_public_path__ + "static/media/importFlybook3.ff15685f.png";